import { initModule } from './init-module';

initModule();

export { PcpLibraryRoutes } from './pcp-library.routes';

export { pcpLibrary } from './pcp-library.config';

export { PrimaryCareProviderLibraryComponent } from './components/primary-care-provider/pcp-library.component';
